import React, { useEffect, useState } from "react";
import styles from "./styles/StaticPage.module.scss";
import { Col, Form, Row } from "react-bootstrap";
import { SubTitle, Button, Input } from "../../Components/CustomComponents";
import { Controller, useForm } from "react-hook-form";
import {
  useGetAppSettingsQuery,
  useUpdateAppSettingsMutation,
} from "../../Data/services/settingApi";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import ClipLoader from "react-spinners/ClipLoader";

const SetCommission = () => {
  const { handleSubmit, control, register, watch, reset } = useForm();

  const {
    data: settingData,
    isLoading,
    refetch,
  } = useGetAppSettingsQuery({
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    console.log(settingData);
    if (settingData && settingData?.data) {
      const {
        title,
        gst,
        platform_fee,
        platform_commission,
        // app_store_url,
        // play_store_url,
      } = settingData?.data;
      reset({
        title: title || "",
        gst: gst || 0,
        platform_fee: platform_fee || 0,
        platform_commission: platform_commission || 0,
        // app_store_url: app_store_url || "",
        // play_store_url: play_store_url || "",
      });
    }
  }, [settingData]);

  const [updateSetting, { isLoading: isUpdating }] =
    useUpdateAppSettingsMutation();

  const handleSaveText = async (data) => {
    // console.log(value
    console.log(data);
    try {
      const response = await updateSetting(data).unwrap();
      console.log(response);

      if (response?.code === 200) {
        SuccessToast("Settings updated successfully");
        refetch();
      } else {
        Toast("Failed to update settings");
      }
    } catch (error) {
      console.error("Error updating settings:", error);
      Toast("Error updating settings", error);
    }
  };

  return (
    <div className={styles.StaticPage}>
      <Form onSubmit={handleSubmit(handleSaveText)}>
        <Row>
          <Col sm={10}>
            <SubTitle text="Set Commission" classes="mb-4" />
          </Col>
          <Col sm={2}>
            <Button
              text={
                isUpdating ? <ClipLoader color="#6457c6" size="22" /> : "Save"
              }
              // classes={`${styles.cardBtn} `}
              classes={`fs-6 mb-2 mt-auto mt-3 mb-2 ${
                isUpdating ? "bg-dark-subtle" : ""
              }`}
              disabled={isUpdating}
              type="submit"
              // onClick={handleSaveText}
            ></Button>
          </Col>
        </Row>

        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center">
            <ClipLoader color="#6457c6" size="22" />
          </div>
        ) : (
          <>
            <Row>
              <Col md={12}>
                <p className="m-0 text-black">Title</p>
                <Controller
                  control={control}
                  name="title"
                  render={({ field: { onChange, onBlur, value, ref } }) => (
                    <Input
                      classes="mt-2 mb-3"
                      type="text"
                      placeholder="Enter title"
                      value={value}
                      onChange={onChange}
                    />
                  )}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <p className="m-0 text-black">GST</p>
                <Controller
                  control={control}
                  name="gst"
                  render={({ field: { onChange, onBlur, value, ref } }) => (
                    <Input
                      classes="mt-2 mb-3"
                      type="number"
                      placeholder="Enter GST"
                      value={value}
                      onChange={onChange}
                    />
                  )}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <p className="m-0 text-black">Platform Fee</p>
                <Controller
                  control={control}
                  name="platform_fee"
                  render={({ field: { onChange, onBlur, value, ref } }) => (
                    <Input
                      classes="mt-2 mb-3"
                      type="number"
                      placeholder="Enter platform fee"
                      value={value}
                      onChange={onChange}
                    />
                  )}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <p className="m-0 text-black">Commission</p>
                <Controller
                  control={control}
                  name="platform_commission"
                  render={({ field: { onChange, onBlur, value, ref } }) => (
                    <Input
                      classes="mt-2 mb-3"
                      type="number"
                      placeholder="Enter platform commission"
                      value={value}
                      onChange={onChange}
                    />
                  )}
                />
              </Col>
            </Row>
            {/* <Row>
<Col md={12}>
  <p className="m-0 text-black">App Store URL</p>
  <Controller
    control={control}
    name="app_store_url"
    render={({ field: { onChange, onBlur, value, ref } }) => (
      <Input
        classes="mt-2 mb-3"
        type="url"
        placeholder="Enter App Store URL"
        value={value}
        onChange={onChange}
      />
    )}
  />
</Col>
</Row>
<Row>
<Col md={12}>
  <p className="m-0 text-black">Play Store URL</p>
  <Controller
    control={control}
    name="play_store_url"
    render={({ field: { onChange, onBlur, value, ref } }) => (
      <Input
        classes="mt-2 mb-3"
        type="url"
        placeholder="Enter Play Store URL"
        value={value}
        onChange={onChange}
      />
    )}
  />
</Col>
</Row> 
*/}
          </>
        )}
      </Form>
    </div>
  );
};

export default SetCommission;
